import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IPerformExtractEncryptionActionOnFlowDraftsRequestParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnFlowDraftsRequest extends Request<IPerformExtractEncryptionActionOnFlowDraftsRequestParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnFlowDrafts', {
      ids: ids,
      type: type
    });
  }
}
